module.exports = __webpack_public_path__ + "static/media/8-ball.3916884c.png";